import React, { useState } from "react";
import PropTypes from "prop-types";
import { getData, postData } from "../../serverRequest";
import LoadingSpinner from "../../components/Loadder";
// import moment from 'moment';
// components
import UserAttendanceApprovalTable from "../Tables/UserAttendanceApprovalTable.js";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";

export default function EmployeeAttendanceRecords({ color }) {
    // const [open, setOpen] = React.useState(true);
    //const [openTickets, setOpenTickets] = React.useState([]);
    //const [closedTicket, setclosedTicket] = React.useState();
    const [attendanceApproval, setAttendanceApproval] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(true);
    const searchParams = new URLSearchParams(window.location.search);
    const [employees, setEmployees] = useState([]);
    const ticketFilter = searchParams.get('filter');
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(localStorage.getItem('employeeId'));
    const [startDate, setStartDate] = useState(new Date());
    const [monthList, setMonthList] = useState([
        { label: "January", value: "1" },
        { label: "February", value: "2" },
        { label: "March", value: "3" },
        { label: "April", value: "4" },
        { label: "May", value: "5" },
        { label: "June", value: "6" },
        { label: "July", value: "7" },
        { label: "August", value: "8" },
        { label: "September", value: "9" },
        { label: "October", value: "10" },
        { label: "November", value: "11" },
        { label: "December", value: "12" },
    ]);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth => {
        const date = new Date();
        const currentMonths = monthList.find(month => month.value === (date.getMonth() + 1).toString());
        return currentMonths ? currentMonths.value : null;
    });
    //console.log(ticketFilter);
    // const toggleDrawer = () => {
    //   setOpen(!open);
    // };

    // const formatDate = (dateString) => {
    //   return moment(dateString).format('DD/MM/YYYY');
    // };

    const filterTicketData = (tickets_data) => {
        //console.log(tickets_data);
        let openTicket = [];
        let closeTicket = [];
        let totalTicket = [];
        if (tickets_data) {
            for (let i = 0; i < tickets_data.length; i++) {
                if (tickets_data[i]['status'] !== 'Resolved') {
                    openTicket.push(tickets_data[i]);
                    totalTicket.push(tickets_data[i]);
                }
                else if (tickets_data[i]['status'] === 'Resolved') {
                    closeTicket.push(tickets_data[i]);
                    totalTicket.push(tickets_data[i]);
                }
                else {
                    totalTicket.push(tickets_data[i]);
                }
            }
        }

        if (ticketFilter === 'open') {
            totalTicket = openTicket;
        }
        else if (ticketFilter === 'closed') {
            totalTicket = closeTicket
        }

        //console.log(totalTicket);
        setAttendanceApproval(totalTicket);
        return ({ "open": openTicket, "close": closeTicket, "total": totalTicket })
    }

    const filterEmployeeData = (employee_data) => {
        //console.log(tickets_data);
        let totalEmployee = [];
        if (employee_data) {
            for (let i = 0; i < employee_data.length; i++) {
                totalEmployee.push(employee_data[i])
            }
        }

        setEmployees(totalEmployee);
        return ({ "total": totalEmployee })
    }

    async function fetchEmployeeData() {
        let resData = await getData('/api/employee/?company_id=' + localStorage.getItem('companyId') + '&is_list_employee=1');
        //let resData = await getData('/api/employee/admins/?is_admin=1')
        let employee_data = resData['data']['employee_data']
        console.log(employee_data);
        let adminData = await filterEmployeeData(employee_data)


        setLoading(false);
    }

    async function fetchData() {
    setTableLoading(true);
    let year = startDate.getFullYear();
    let resData = await getData('/api/employee/employee_monthly_attendance?employee_id=' + selectedEmployee + '&month='+selectedMonth + '&date='+startDate + '&year='+ year+ '&company_id=' + localStorage.getItem('companyId'));
    let attendance_data = resData['data']['data'];
    // console.log(attendance_data);
        // let ticketData = await filterTicketData(tickets_data)
        setTableLoading(false);
        setLoading(false);
        setAttendanceApproval(attendance_data);
    }

    React.useEffect(() => {

        fetchData();
        fetchEmployeeData();

    }, [startDate])

    return (
        <>
            {loading ? (
                <LoadingSpinner></LoadingSpinner>
            ) : (
                <>
                    <div
                        className={
                            "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                            "bg-white"
                        }
                    >
                        <div className="rounded-t bg-white mb-0 px-6 py-6">
                            <div className="text-center flex justify-between">
                                <h6 className="text-blueGray-700 text-xl font-bold">Employee Attendance</h6>
                                <div className="w-full lg:w-3/12 px-4">
                                    <div className="relative w-full">
                                        <Select name="clist"
                                            options={employees.map(employee => ({
                                                label: `${employee.first_name} ${employee.last_name}`,
                                                value: employee.id
                                            }))}
                                            getOptionLabel={(option) => option.label}
                                            getOptionValue={(option) => option.value}
                                            value={selectedOption}
                                            onChange={(selectedOption) => {
                                                setSelectedOption(selectedOption);
                                                setSelectedEmployee(selectedOption.value);
                                                fetchData();
                                                //console.log(selectedOption.value);
                                                //window.location.reload();
                                            }}
                                            placeholder="Select Employee">
                                        </Select>
                                    </div>
                                </div>
                                <div className="w-full lg:w-3/12 px-4">
                                    <div className="relative w-full">
                                        <Select
                                            name="monthList"
                                            options={monthList}
                                            className="basic-single"
                                            value={selectedMonth ? monthList.find(month => month.value === selectedMonth) : null}
                                            onChange={(selectedOption) => {
                                                setSelectedOption(selectedOption);
                                                setSelectedMonth(selectedOption.value);
                                                const newDate = new Date(startDate);
                                                newDate.setMonth(parseInt(selectedOption.value) - 1);
                                                setStartDate(newDate);
                                                fetchData();
                                            }}
                                            placeholder="Select Month"
                                        />
                                    </div>
                                </div>
                                {/* <Link to="/admin/company/incidentForm">
                                <button
                                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                    type="button">
                                    Add
                                </button>
                            </Link> */}
                            </div>
                        </div>
                        <div className="block w-full overflow-x-auto mb-0 px-4 py-3">
                            {tableLoading ? (
                                <LoadingSpinner></LoadingSpinner>
                            ) : (
                                <table
                                    id="userAttendanceApproval"
                                    className="items-center w-full bg-transparent border-collapse"
                                >
                                    <thead>
                                        <tr>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                }
                                            >
                                                Date
                                            </th>
                                            <th
                                                className={
                                                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                                                    " bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                                                }
                                            >
                                                Attendance
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {attendanceApproval && attendanceApproval.map((item, index) => (
                                            <tr key={index}>
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                    {item.date}
                                                </td>
                                                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                                                    {item.status_display}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                        <ToastContainer />
                    </div>
                </>
            )}
        </>
    );

    async function handleAction(id, action) {
        console.log(`Action: ${action} for ID: ${id}`);
        setLoading(true);
        const reqData = {
            leave_request_id: id,
            approver_id: localStorage.getItem('employeeId'),
            company_id: localStorage.getItem('companyId'),
            action: action
        };
        // Add logic to handle approve/reject action
        //console.log(reqData);
        let resData = await postData('/api/employee/approver_action/', reqData)
        setLoading(false);
        //console.log("This is data")
        //console.log(resData)
        if (resData['data']['code'] === 200) {
            setLoading(false);
            toast.success(resData['data']['message']);
            //console.log("This is good example");
            //window.location.href = '/user/dashboard';
        }
        else {
            toast.error(resData['data']['message']);
            //setErrorMessages({ name: "uname", message: errors.uname });
        }
    }
}

EmployeeAttendanceRecords.defaultProps = {
    color: "light",
};

EmployeeAttendanceRecords.propTypes = {
    color: PropTypes.oneOf(["light", "dark"]),
};
